<template>
  <div class="card flex justify-center">
    <Dialog
      v-if="visible"
      v-model:visible="visible"
      :closeable="true"
      modal
      :header="header"
      :style="{ width: '25rem' }"
    >
      <span
        class="text-surface-500 dark:text-surface-400 block mb-8"
        v-html="message"
      ></span>
    </Dialog>
  </div>
</template>


<script>
import Dialog from 'primevue/dialog';

export default {
  name: 'MaintenancePopUp',
  components: {
    Dialog,
  },
  props: {
    header: {
      type: String,
      default: 'Wartungsarbeiten an der Reklamationsliste',
    },
    message: {
      type: String,
      default:
        'Liebe Nutzer und Nutzerinnen, <br><br>die Reklamationsliste befindet sich derzeit in Wartungsarbeiten. <br><h4>Weshalb Daten möglicherweise nicht gespeichert werden.</h4><br>Wir bitten um Ihr Verständnis.<br><br>Mit freundlichen Grüßen,<br><strong>Lee Daniel Hertel</strong><br><i>Entwickler der Reklamationsliste</i>',
    },
    saveCookie: {
      type: [Boolean, String], // since you're passing it as a string like `saveCookie="true"`
      default: false,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  mounted() {
    const cookies = document.cookie.split(';').map(c => c.trim());
    const seen = cookies.some(c => c.startsWith('maintenancePopupSeen2='));

    if (seen) {
      this.visible = false;
    } else {
      this.visible = true;
      if (this.saveCookie === true || this.saveCookie === 'true') {
        document.cookie = "closureAgreementSeen=true; max-age=604800; path=/";
      }
    }
  },
};
</script>
